/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ViewDetailsV2Container, ViewDetailsV2ContainerProps } from './ViewDetailsV2.container';

export { ViewDetailsV2Container as ViewDetailsV2 };
export type ViewDetailsV2Props = ViewDetailsV2ContainerProps;
